// ABOUTME: What blocks a cascading delete, from its preview: a plan above the size cap, or read-only nodes in it.
// ABOUTME: Shared by the delete dialog and the bulk change's cascade preview; renders nothing when nothing blocks.

import { Alert } from '@ds/coolshop';
import { useIntl } from 'react-intl';

type CascadeBlockersAlertProps = {
    capExceeded: boolean;
    lockedNodes: { code: string }[];
};

export function CascadeBlockersAlert({ capExceeded, lockedNodes }: CascadeBlockersAlertProps) {
    const { formatMessage } = useIntl();
    return (
        <>
            {capExceeded && (
                <Alert severity="warning">
                    {formatMessage({
                        id: 'node-delete.cascade-cap-exceeded',
                        defaultMessage:
                            'The cascading delete covers too many nodes to run in a single operation. Remove some links first, or delete in smaller steps.',
                    })}
                </Alert>
            )}
            {lockedNodes.length > 0 && (
                <Alert severity="error">
                    {formatMessage(
                        {
                            id: 'node-delete.cascade-locked-nodes',
                            defaultMessage:
                                'These nodes are read-only and block the delete: {codes}',
                        },
                        { codes: lockedNodes.map(n => n.code).join(', ') },
                    )}
                </Alert>
            )}
        </>
    );
}
